import moment from 'moment';

export default {
  getTimeFormat(date, format) {
    if (!date) return '';
    return moment(date).format(format);
  },
};
